import { UploadedAttachment } from 'aos-services/src/services/attachments/types/UploadedAttachment'
import React, { FCWithChildren } from 'react'
import styled from 'styled-components'

import { Box } from '../../base/Box'
import { AttachmentContainerItem } from './AttachmentContainerItem'
import { PreviewableProps } from './PreviewableProps'

interface PreviewablePhotoProps extends PreviewableProps {
    attachment: UploadedAttachment
}

export const PreviewableFile: FCWithChildren<PreviewablePhotoProps> = ({ attachment, ...rest }) => {
    return (
        <AttachmentContainerItem {...rest}>
            <Box coverAll>
                <Iframe src={`${attachment.link}#toolbar=0`} />
            </Box>
        </AttachmentContainerItem>
    )
}

const Iframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background-color: transparent;
`
